import { last } from 'lodash';
import { useIntl } from 'react-intl';

import { getShouldShowCurrentAnswersStatus } from '../../problem/common-utils';
import { useCodingPropsSelector } from '../context';
import { useCodingStore } from '../state';

const CheckDetailsStatusVerdict: string[] = ['ok', 'mistake'] as const;

const CheckDetailsExceptionStatusVerdict: Record<string, string> = {
    /* eslint-disable-next-line */
    timeout_waiting_payload_execution: 'problemCoding.verdict.Timeout', // Для обратной совместимости!
    CodeCompletionTimeout: 'problemCoding.verdict.Timeout',
    YandexCloudTimeoutException: 'problemCoding.verdict.Timeout',
    // RpsLimitExceededException: RobotErrorType.SYNTAX,
    SyntaxError: 'problemCoding.verdict.SyntaxError',
    IndentationException: 'problemCoding.verdict.IndentationError',
    // UnknownException: RobotErrorType.SYNTAX,
} as const;

export function useGetMessage(): string | null {
    const intl = useIntl();
    const selectedTest = useCodingStore((s) => s.selectedTest);
    const attempt = useCodingPropsSelector((p) => p.attempt);
    const showCurrentAnswersStatus = useCodingPropsSelector(getShouldShowCurrentAnswersStatus);

    const result = attempt?.markers?.result[selectedTest];

    const results = attempt && Object.values(attempt.markers?.result || {});
    const allCorrect = results && results.length > 0 && results.every((r) => r.answer_status);

    if (allCorrect) {
        if (!showCurrentAnswersStatus) {
            return null;
        }
        return intl.formatMessage({ id: 'problemCoding.verdict.allCorrect' });
    }
    const checkDetails = result?.check_details;

    if (checkDetails && checkDetails.status && CheckDetailsStatusVerdict.indexOf(checkDetails.status) === -1) {
        const errType = checkDetails.status.split(':')[0];
        const errMessage =
            CheckDetailsExceptionStatusVerdict[errType] || CheckDetailsExceptionStatusVerdict.SyntaxError;
        return intl.formatMessage({ id: errMessage });
    }

    const checkError = last(checkDetails?.check_results)?.result.data;
    if (typeof checkError === 'object') {
        if (checkError && typeof checkError.error === 'string') {
            return checkError.error;
        }
    }
    if (typeof checkError === 'string') {
        return checkError;
    }
    const exception = checkDetails?.exception_message || checkDetails?.exception;
    if (typeof exception === 'string') {
        return exception;
    }
    if (!showCurrentAnswersStatus) {
        return null;
    }
    return intl.formatMessage({ id: 'problemCoding.verdict.incorrect' });
}
